/* eslint-disable react/jsx-props-no-spreading */
import React, { SVGProps } from 'react';

const EyeClosed = (props: SVGProps<SVGSVGElement>) => (
  <svg width={18} height={18} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M7.425 3.18A6.84 6.84 0 0 1 9 3c5.25 0 8.25 6 8.25 6a13.875 13.875 0 0 1-1.62 2.393m-5.04-.803a2.25 2.25 0 1 1-3.18-3.18m6.045 6.045A7.552 7.552 0 0 1 9 15C3.75 15 .75 9 .75 9a13.837 13.837 0 0 1 3.795-4.455l8.91 8.91ZM.75.75l16.5 16.5"
      stroke="var(--secondaryText)"
      fill="none"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default EyeClosed;
